module.exports = __webpack_public_path__ + "static/media/redbanana.a6ad3ea4.jpg";